import { GlobalState } from '@store';

export const getProductTags = (state: GlobalState) => state.productTags.list;
export const getActiveProductTags = (state: GlobalState) => state.productTags.list[state.productTags.activeCategory];
export const getVisibleActiveProductCategory = (state: GlobalState) => state.productTags.activeCategory;
